'use client';
// Escena 3D del hero: libro, teléfono y nota siguen al mouse con inercia.
// El movimiento va por variables CSS (--px/--py) en el nodo: no re-renderiza.
import { useEffect, useRef } from 'react';

export default function EscenaHero() {
  const ref = useRef(null);
  const st = useRef({ cur: { x: 0, y: 0 }, target: { x: 0, y: 0 }, raf: 0, rect: null });

  useEffect(() => () => cancelAnimationFrame(st.current.raf), []);

  // Libro, teléfono y nota: dentro de la escena 3D que se inclina, Chrome
  // tarda segundos en aplicar :hover y dispara pointerenter/leave seguidos.
  // Se decide por geometría: el rectángulo en pantalla de cada objeto.
  function marcarActivo(x, y) {
    const nodos = [...(ref.current?.querySelectorAll('[data-activable]') ?? [])];
    let elegido = null;
    for (const n of nodos) {
      const r = n.getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) elegido = n;
    }
    nodos.forEach((n) => n.classList.toggle('activo', n === elegido));
  }

  function tick() {
    const s = st.current;
    s.cur.x += (s.target.x - s.cur.x) * 0.06;
    s.cur.y += (s.target.y - s.cur.y) * 0.06;
    if (ref.current) {
      ref.current.style.setProperty('--px', s.cur.x.toFixed(4));
      ref.current.style.setProperty('--py', s.cur.y.toFixed(4));
    }
    const sigue = Math.abs(s.target.x - s.cur.x) > 0.0008 || Math.abs(s.target.y - s.cur.y) > 0.0008;
    s.raf = sigue ? requestAnimationFrame(tick) : 0;
  }

  function irA(x, y) {
    st.current.target = { x, y };
    if (!st.current.raf) st.current.raf = requestAnimationFrame(tick);
  }

  function entrar(e) {
    st.current.rect = e.currentTarget.getBoundingClientRect();
  }

  function mover(e) {
    marcarActivo(e.clientX, e.clientY);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const s = st.current;
    if (!s.rect) s.rect = e.currentTarget.getBoundingClientRect();
    irA((e.clientX - s.rect.left) / s.rect.width - 0.5, (e.clientY - s.rect.top) / s.rect.height - 0.5);
  }

  function salir() {
    marcarActivo(-1, -1);
    irA(0, 0);
    st.current.rect = null;
  }

  return (
<div className="escena" ref={ref} onMouseEnter={entrar} onMouseMove={mover} onMouseLeave={salir} aria-hidden="true" style={{ flex: "1 1 520px", minWidth: "0", position: "relative", perspective: "1600px" }}>
<div className="escenario" style={{ position: "absolute", left: "50%", top: "0", width: "560px", height: "620px", transformOrigin: "top center", perspective: "1600px", transformStyle: "preserve-3d" }}>
<div style={{ position: "absolute", left: "6%", right: "6%", bottom: "30px", height: "60px", borderRadius: "50%", background: "#0F172A", opacity: "0.13", filter: "blur(24px)", transform: "translate3d(calc(var(--px, 0) * -26px), 0, 0)" }}></div>
<div style={{ position: "absolute", inset: "0", transformStyle: "preserve-3d", transform: "rotateX(calc(var(--py, 0) * -9deg)) rotateY(calc(var(--px, 0) * 12deg))" }}>

<div className="flota2" style={{ position: "absolute", left: "10px", top: "150px", transformStyle: "preserve-3d" }}>
<div style={{ transform: "translate3d(calc(var(--px, 0) * -22px), calc(var(--py, 0) * -14px), 0)", transformStyle: "preserve-3d" }}>
<div className="libro" data-activable="" style={{ width: "210px", height: "290px", perspective: "1200px" }}>
<div className="libro-in t3d" style={{ position: "relative", width: "210px", height: "290px", transformStyle: "preserve-3d", transform: "rotateY(28deg) rotateX(4deg)" }}>
<div style={{ position: "absolute", inset: "3px 4px 3px 0", transform: "translateZ(24px)", background: "#FFFFFF", borderRadius: "2px 10px 10px 2px", padding: "26px 18px 18px 26px", boxSizing: "border-box" }}>
<div className="txt-interior" style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
<span className="serif" style={{ fontSize: "15px", fontWeight: "600", color: "#002366" }}>Art. 80</span>
<span style={{ fontSize: "11px", lineHeight: "1.5", color: "#475569" }}>Ord. 3.º: después de un trabajo continuo no menor de un año ni mayor de cinco, veintiún días de salario ordinario por cada año…</span>
<span style={{ height: "4px", width: "90%", background: "#E5E4E2", borderRadius: "2px" }}></span>
<span style={{ height: "4px", width: "75%", background: "#E5E4E2", borderRadius: "2px" }}></span>
<span className="mano" style={{ fontSize: "18px", color: "#7A5C00", marginTop: "6px" }}>aquí está</span>
</div>
</div>
<div className="tapa t3d" style={{ position: "absolute", inset: "0", background: "#002366", borderRadius: "4px 14px 14px 4px", boxShadow: "inset 10px 0 0 rgba(0,0,0,0.18)", display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "26px 18px 22px 28px", boxSizing: "border-box", color: "#D4B47A" }}>
<span className="serif" style={{ fontSize: "27px", lineHeight: "1.05", fontWeight: "600" }}>Código de Trabajo</span>
<span style={{ fontSize: "13px", letterSpacing: "0.04em", color: "#C5A059" }}>República Dominicana</span>
</div>
<div style={{ position: "absolute", top: "0", left: "0", width: "52px", height: "290px", transformOrigin: "left center", transform: "translateZ(26px) rotateY(-90deg)", background: "#001A4D", borderRadius: "4px 0 0 4px" }}></div>
<div style={{ position: "absolute", top: "4px", right: "0", width: "50px", height: "282px", transformOrigin: "right center", transform: "translateZ(24px) rotateY(90deg)", background: "repeating-linear-gradient(90deg, #FFFFFF 0 2px, #E5E4E2 2px 3px)", borderRadius: "2px" }}></div>
<div style={{ position: "absolute", top: "0", left: "4px", width: "200px", height: "50px", transformOrigin: "top center", transform: "translateZ(24px) rotateX(-90deg)", background: "repeating-linear-gradient(0deg, #FFFFFF 0 2px, #E5E4E2 2px 3px)" }}></div>
<div className="marcador t3d" style={{ position: "absolute", top: "-22px", left: "140px", width: "16px", height: "60px", transform: "translateZ(27px)", background: "#B8860B", borderRadius: "0 0 3px 3px" }}></div>
</div>
</div>
</div>
</div>

<div className="flota retraso2" style={{ position: "absolute", right: "16px", top: "24px", transformStyle: "preserve-3d" }}>
<div style={{ transform: "translate3d(calc(var(--px, 0) * 18px), calc(var(--py, 0) * 12px), 0)", transformStyle: "preserve-3d" }}>
<div className="tel" data-activable="" style={{ width: "270px", height: "550px", perspective: "1400px" }}>
<div className="tel-in t3d" style={{ position: "relative", width: "270px", height: "550px", transformStyle: "preserve-3d", transform: "rotateY(-20deg) rotateX(6deg) rotateZ(2deg)" }}>
<div style={{ position: "absolute", inset: "0", transform: "translateZ(9px)", background: "#0F172A", borderRadius: "46px", padding: "12px", boxSizing: "border-box" }}>
<div style={{ width: "100%", height: "100%", borderRadius: "35px", background: "#FAF9F6", overflow: "hidden", display: "flex", flexDirection: "column" }}>
<div className="marca" style={{ padding: "22px 18px 12px", fontSize: "15px", color: "#002366", textAlign: "center" }}>Dr. Víctor</div>
<div style={{ flex: "1", padding: "6px 14px", display: "flex", flexDirection: "column", gap: "12px" }}>
<div style={{ alignSelf: "flex-end", maxWidth: "86%", background: "#002366", color: "#FAF9F6", fontSize: "13px", lineHeight: "1.45", padding: "10px 12px", borderRadius: "16px 16px 4px 16px" }}>Desahuciaron a mi cliente con 3 años. ¿Qué le toca?</div>
<div style={{ maxWidth: "92%", background: "#FFFFFF", fontSize: "13px", lineHeight: "1.5", padding: "12px", borderRadius: "16px 16px 16px 4px", boxShadow: "0 2px 0 #E5E4E2" }}>Si no le dieron el preaviso: 28 días de salario. Más 63 días de cesantía. Plazo para pagar: 10 días.</div>
<div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
<span style={{ fontSize: "11px", fontWeight: "600", padding: "5px 8px", borderRadius: "8px", background: "rgba(184,134,11,0.14)", color: "#6B5000" }}>CT arts. 76 y 79</span>
<span style={{ fontSize: "11px", fontWeight: "600", padding: "5px 8px", borderRadius: "8px", background: "rgba(184,134,11,0.14)", color: "#6B5000" }}>CT art. 80</span>
<span style={{ fontSize: "11px", fontWeight: "600", padding: "5px 8px", borderRadius: "8px", background: "rgba(184,134,11,0.14)", color: "#6B5000" }}>CT art. 86</span>
</div>
<div className="nuevo uno" style={{ alignSelf: "flex-end", maxWidth: "86%", background: "#002366", color: "#FAF9F6", fontSize: "13px", lineHeight: "1.45", padding: "10px 12px", borderRadius: "16px 16px 4px 16px" }}>¿Y si se atrasa?</div>
<div className="nuevo dos" style={{ alignSelf: "flex-start", background: "#FFFFFF", padding: "12px 14px", borderRadius: "16px 16px 16px 4px", boxShadow: "0 2px 0 #E5E4E2", display: "flex", gap: "4px" }}>
<span className="punto" style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#64748B" }}></span>
<span className="punto" style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#64748B", animationDelay: ".18s" }}></span>
<span className="punto" style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#64748B", animationDelay: ".36s" }}></span>
</div>
</div>
<div style={{ margin: "12px", padding: "12px 14px", borderRadius: "18px", background: "#F3F1EC", fontSize: "12px", color: "#475569" }}>Escríbele a Víctor…</div>
</div>
</div>
<div style={{ position: "absolute", top: "40px", right: "0", width: "18px", height: "470px", transformOrigin: "right center", transform: "translateZ(9px) rotateY(90deg)", background: "#1E293B", borderRadius: "9px" }}></div>
<div style={{ position: "absolute", top: "40px", left: "0", width: "18px", height: "470px", transformOrigin: "left center", transform: "translateZ(9px) rotateY(-90deg)", background: "#0B1222", borderRadius: "9px" }}></div>
</div>
</div>
</div>
</div>

<div className="nota" data-activable="" style={{ position: "absolute", left: "40px", bottom: "34px", transform: "translateZ(70px)" }}>
<div style={{ transform: "translate3d(calc(var(--px, 0) * 40px), calc(var(--py, 0) * 26px), 0)" }}>
<div className="flota3 retraso1">
<div className="nota-in t3d mano" style={{ background: "#F1E3BC", color: "#0F172A", width: "190px", padding: "18px 16px", boxSizing: "border-box", fontSize: "24px", lineHeight: "1.1", boxShadow: "0 14px 24px -12px rgba(15,23,42,0.4)" }}>Te dice de dónde lo sacó</div>
</div>
</div>
</div>

</div>
</div>
</div>
  );
}
